"use strict";
/**
 * Navigation Service
 * Handles page navigation and routing
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigateToPage = navigateToPage;
exports.navigateToWinProb = navigateToWinProb;
exports.navigateToEvents = navigateToEvents;
exports.navigateToOrder = navigateToOrder;
exports.navigateToPairBuilder = navigateToPairBuilder;
exports.navigateToMonitorStatus = navigateToMonitorStatus;
exports.navigateToPnl = navigateToPnl;
exports.navigateToLogin = navigateToLogin;
const state_1 = require("../state");
const win_prob_handler_1 = require("../handlers/win-prob-handler");
const ui_1 = require("../ui");
/**
 * Navigate to a specific page
 */
function navigateToPage(page) {
    // The win-prob page runs its own poll timer; stop it on the way out so it
    // cannot outlive the view (handlers/win-prob-handler.ts).
    if ((0, state_1.getState)().currentPage === "win-prob" && page !== "win-prob") {
        (0, win_prob_handler_1.teardownWinProbPage)();
    }
    (0, state_1.updateState)({ currentPage: page });
}
/**
 * Navigate to the win-probability page (owner tier; gated in gates.ts and
 * enforced on the /win-prob router) and open its list, or the game/pad the
 * `/app/win-prob/...` segments name. Showing the container alone leaves the
 * page blank: the list only loads through openWinProbRoute.
 */
function navigateToWinProb(segments = [], query) {
    navigateToPage("win-prob");
    (0, win_prob_handler_1.openWinProbRoute)(segments, query);
}
/**
 * Navigate to events page
 */
function navigateToEvents() {
    (0, ui_1.hideOrderbookError)();
    (0, ui_1.hideMarketSwitcher)();
    (0, ui_1.hideMarketNavButtons)();
    // Clear market selection state and navigate
    // State change will trigger stopAllPolling via handleStateChange
    (0, state_1.updateState)({
        currentPage: "events",
        selectedMarket: null,
        parallelMarkets: [],
        selectedEventTicker: null,
        availableMarkets: null,
        currentPosition: null,
        orderBook: null,
        cachedBidAsk: undefined,
    });
}
/**
 * Navigate to order page
 */
function navigateToOrder() {
    navigateToPage("order");
}
/**
 * Navigate to pair builder page
 */
function navigateToPairBuilder() {
    navigateToPage("pair-builder");
}
/**
 * Navigate to monitor status page
 */
function navigateToMonitorStatus() {
    navigateToPage("monitor-status");
}
/**
 * Navigate to the PNL (bet-performance) page.
 * This page is read-only and does not poll, so there is no market state to
 * clear here — the handler manages its own selectors and data.
 */
function navigateToPnl() {
    navigateToPage("pnl");
}
/**
 * Navigate to login page
 */
function navigateToLogin() {
    navigateToPage("login");
}
